// src/components/Locations.jsx
import React from 'react';
import amsterdam from '../../assets/a.png';
import berlin   from '../../assets/b.png';
import boston   from '../../assets/c.png';
import istanbul from '../../assets/d.png';

export default function Locations() {
  const cities = [
    { name: 'Amsterdam', image: amsterdam },
    { name: 'Berlin',    image: berlin   },
    { name: 'Boston',    image: boston   },
    { name: 'Istanbul',  image: istanbul },
  ];

  return (
    <section className="w-full py-20 px-4 bg-white" id="locations">
      <div className="max-w-[1600px] mx-auto">
        {/* Başlık + Açıklama */}
        <h2 className="text-[50px] sm:text-[80px] font-questrial text-[#22282b] mb-6">
          Locations
        </h2>
        <p className="text-[18px] sm:text-[35px] font-manrope text-[#22282b] mb-12">
          We operate across Amsterdam, Berlin, Boston, and Istanbul, allowing us to bring global perspective and local understanding to every project.
        </p>

        {/* ─── Grid ile gap-0, sadece uçlara rounded uygulama ─── */}
        <div className="grid grid-cols-4 gap-0">
          {cities.map((city, idx) => (
            <div
              key={city.name}
              className={`
                relative overflow-hidden
                ${idx === 0 ? 'rounded-l-[40px]' : ''}
                ${idx === cities.length - 1 ? 'rounded-r-[40px]' : ''}
              `}
            >
              <img
                src={city.image}
                alt={city.name}
                className="w-full h-[280px] object-cover"
              />
              <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2">
              <span className="text-white font-manrope text-base sm:text-2xl">
         {city.name}
       </span>
     </div>
            </div>
          ))}
        </div>

       

      </div>
    </section>
  );
}
